// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/rag/v1/rag.proto (package mono.rag.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct } from "@bufbuild/protobuf";
import { Principal } from "../../common/v1/types_pb";
/**
 * @generated from message mono.rag.v1.SearchRequest
 */ export class SearchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.Principal user_context = 3;
   */ _define_property(this, "userContext", void 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: float score_threshold = 5;
   */ _define_property(this, "scoreThreshold", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchRequest, "runtime", proto3);
_define_property(SearchRequest, "typeName", "mono.rag.v1.SearchRequest");
_define_property(SearchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_context",
            kind: "message",
            T: Principal
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "score_threshold",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.SearchResponse
 */ export class SearchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.rag.v1.SearchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchResponse, "runtime", proto3);
_define_property(SearchResponse, "typeName", "mono.rag.v1.SearchResponse");
_define_property(SearchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: SearchResult,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.SearchResult
 */ export class SearchResult extends Message {
    static fromBinary(bytes, options) {
        return new SearchResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: float score = 3;
   */ _define_property(this, "score", 0), /**
   * @generated from field: google.protobuf.Struct metadata = 4;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchResult, "runtime", proto3);
_define_property(SearchResult, "typeName", "mono.rag.v1.SearchResult");
_define_property(SearchResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 4,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.rag.v1.SearchSimilarRequest
 */ export class SearchSimilarRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchSimilarRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchSimilarRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchSimilarRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchSimilarRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.Principal user_context = 3;
   */ _define_property(this, "userContext", void 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchSimilarRequest, "runtime", proto3);
_define_property(SearchSimilarRequest, "typeName", "mono.rag.v1.SearchSimilarRequest");
_define_property(SearchSimilarRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_context",
            kind: "message",
            T: Principal
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.SearchSimilarResponse
 */ export class SearchSimilarResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchSimilarResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchSimilarResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchSimilarResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchSimilarResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.rag.v1.SearchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: string request_id = 2;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchSimilarResponse, "runtime", proto3);
_define_property(SearchSimilarResponse, "typeName", "mono.rag.v1.SearchSimilarResponse");
_define_property(SearchSimilarResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: SearchResult,
            repeated: true
        },
        {
            no: 2,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.GetDocumentRequest
 */ export class GetDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.Principal user_context = 3;
   */ _define_property(this, "userContext", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentRequest, "runtime", proto3);
_define_property(GetDocumentRequest, "typeName", "mono.rag.v1.GetDocumentRequest");
_define_property(GetDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_context",
            kind: "message",
            T: Principal
        }
    ]));
/**
 * @generated from message mono.rag.v1.GetDocumentResponse
 */ export class GetDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: google.protobuf.Struct metadata = 3;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentResponse, "runtime", proto3);
_define_property(GetDocumentResponse, "typeName", "mono.rag.v1.GetDocumentResponse");
_define_property(GetDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "metadata",
            kind: "message",
            T: Struct
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.EmbedRequest
 */ export class EmbedRequest extends Message {
    static fromBinary(bytes, options) {
        return new EmbedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string model = 2;
   */ _define_property(this, "model", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmbedRequest, "runtime", proto3);
_define_property(EmbedRequest, "typeName", "mono.rag.v1.EmbedRequest");
_define_property(EmbedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.EmbedResponse
 */ export class EmbedResponse extends Message {
    static fromBinary(bytes, options) {
        return new EmbedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated float embedding = 1;
   */ _define_property(this, "embedding", []), /**
   * @generated from field: string model = 2;
   */ _define_property(this, "model", ""), /**
   * @generated from field: int32 dimensions = 3;
   */ _define_property(this, "dimensions", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmbedResponse, "runtime", proto3);
_define_property(EmbedResponse, "typeName", "mono.rag.v1.EmbedResponse");
_define_property(EmbedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "embedding",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ ,
            repeated: true
        },
        {
            no: 2,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dimensions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.EmbedBatchRequest
 */ export class EmbedBatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new EmbedBatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbedBatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbedBatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbedBatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string texts = 1;
   */ _define_property(this, "texts", []), /**
   * @generated from field: string model = 2;
   */ _define_property(this, "model", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmbedBatchRequest, "runtime", proto3);
_define_property(EmbedBatchRequest, "typeName", "mono.rag.v1.EmbedBatchRequest");
_define_property(EmbedBatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "texts",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.EmbedBatchResponse
 */ export class EmbedBatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new EmbedBatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbedBatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbedBatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbedBatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.rag.v1.Embedding embeddings = 1;
   */ _define_property(this, "embeddings", []), /**
   * @generated from field: string model = 2;
   */ _define_property(this, "model", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EmbedBatchResponse, "runtime", proto3);
_define_property(EmbedBatchResponse, "typeName", "mono.rag.v1.EmbedBatchResponse");
_define_property(EmbedBatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "embeddings",
            kind: "message",
            T: Embedding,
            repeated: true
        },
        {
            no: 2,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.Embedding
 */ export class Embedding extends Message {
    static fromBinary(bytes, options) {
        return new Embedding().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Embedding().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Embedding().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Embedding, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated float values = 1;
   */ _define_property(this, "values", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Embedding, "runtime", proto3);
_define_property(Embedding, "typeName", "mono.rag.v1.Embedding");
_define_property(Embedding, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "values",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.rag.v1.SemanticSearchRequest
 */ export class SemanticSearchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SemanticSearchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SemanticSearchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SemanticSearchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SemanticSearchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.Principal user_context = 3;
   */ _define_property(this, "userContext", void 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: float score_threshold = 5;
   */ _define_property(this, "scoreThreshold", 0), /**
   * Filters for scoped retrieval.
   *
   * SECTION_L, PWS, SOW, etc.
   *
   * @generated from field: repeated string document_types = 6;
   */ _define_property(this, "documentTypes", []), /**
   * source_document, project_file
   *
   * @generated from field: string file_category = 7;
   */ _define_property(this, "fileCategory", ""), /**
   * solicitation, amendment, qa, attachment
   *
   * @generated from field: string source_kind = 8;
   */ _define_property(this, "sourceKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SemanticSearchRequest, "runtime", proto3);
_define_property(SemanticSearchRequest, "typeName", "mono.rag.v1.SemanticSearchRequest");
_define_property(SemanticSearchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_context",
            kind: "message",
            T: Principal
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "score_threshold",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 6,
            name: "document_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.SemanticSearchResponse
 */ export class SemanticSearchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SemanticSearchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SemanticSearchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SemanticSearchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SemanticSearchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.rag.v1.SearchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SemanticSearchResponse, "runtime", proto3);
_define_property(SemanticSearchResponse, "typeName", "mono.rag.v1.SemanticSearchResponse");
_define_property(SemanticSearchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: SearchResult,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.CreateCollectionRequest
 */ export class CreateCollectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCollectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCollectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCollectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCollectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCollectionRequest, "runtime", proto3);
_define_property(CreateCollectionRequest, "typeName", "mono.rag.v1.CreateCollectionRequest");
_define_property(CreateCollectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.CreateCollectionResponse
 */ export class CreateCollectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCollectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCollectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCollectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCollectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCollectionResponse, "runtime", proto3);
_define_property(CreateCollectionResponse, "typeName", "mono.rag.v1.CreateCollectionResponse");
_define_property(CreateCollectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.DeleteCollectionRequest
 */ export class DeleteCollectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCollectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCollectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCollectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCollectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCollectionRequest, "runtime", proto3);
_define_property(DeleteCollectionRequest, "typeName", "mono.rag.v1.DeleteCollectionRequest");
_define_property(DeleteCollectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.DeleteCollectionResponse
 */ export class DeleteCollectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCollectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCollectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCollectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCollectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCollectionResponse, "runtime", proto3);
_define_property(DeleteCollectionResponse, "typeName", "mono.rag.v1.DeleteCollectionResponse");
_define_property(DeleteCollectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.GetCollectionStatsRequest
 */ export class GetCollectionStatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCollectionStatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCollectionStatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCollectionStatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCollectionStatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCollectionStatsRequest, "runtime", proto3);
_define_property(GetCollectionStatsRequest, "typeName", "mono.rag.v1.GetCollectionStatsRequest");
_define_property(GetCollectionStatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.GetCollectionStatsResponse
 */ export class GetCollectionStatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCollectionStatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCollectionStatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCollectionStatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCollectionStatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: int64 document_count = 2;
   */ _define_property(this, "documentCount", protoInt64.zero), /**
   * @generated from field: int64 vector_count = 3;
   */ _define_property(this, "vectorCount", protoInt64.zero), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCollectionStatsResponse, "runtime", proto3);
_define_property(GetCollectionStatsResponse, "typeName", "mono.rag.v1.GetCollectionStatsResponse");
_define_property(GetCollectionStatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "vector_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * IndexableBlock represents a document chunk ready for vector indexing.
 *
 * @generated from message mono.rag.v1.IndexableBlock
 */ export class IndexableBlock extends Message {
    static fromBinary(bytes, options) {
        return new IndexableBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexableBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexableBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexableBlock, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * SECTION_L, PWS, SOW, CDRL, etc.
   *
   * @generated from field: string document_type = 5;
   */ _define_property(this, "documentType", ""), /**
   * L.5.1, 3.2.1
   *
   * @generated from field: string section_number = 6;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 page_number = 7;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: bool is_amendment = 8;
   */ _define_property(this, "isAmendment", false), /**
   * @generated from field: string amendment_number = 9;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: string base_document_id = 10;
   */ _define_property(this, "baseDocumentId", ""), /**
   * @generated from field: int32 version = 11;
   */ _define_property(this, "version", 0), /**
   * @generated from field: int64 document_date = 12;
   */ _define_property(this, "documentDate", protoInt64.zero), /**
   * source_document, project_file
   *
   * @generated from field: string file_category = 13;
   */ _define_property(this, "fileCategory", ""), /**
   * solicitation, amendment, qa, attachment, contract_mod
   *
   * @generated from field: string source_kind = 14;
   */ _define_property(this, "sourceKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndexableBlock, "runtime", proto3);
_define_property(IndexableBlock, "typeName", "mono.rag.v1.IndexableBlock");
_define_property(IndexableBlock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "base_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "document_date",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 13,
            name: "file_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.IndexDocumentRequest
 */ export class IndexDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new IndexDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.rag.v1.IndexableBlock blocks = 3;
   */ _define_property(this, "blocks", []), /**
   * If true, overwrites existing blocks by block_id
   *
   * @generated from field: bool force_reindex = 4;
   */ _define_property(this, "forceReindex", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndexDocumentRequest, "runtime", proto3);
_define_property(IndexDocumentRequest, "typeName", "mono.rag.v1.IndexDocumentRequest");
_define_property(IndexDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "blocks",
            kind: "message",
            T: IndexableBlock,
            repeated: true
        },
        {
            no: 4,
            name: "force_reindex",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.IndexDocumentResponse
 */ export class IndexDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new IndexDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 indexed_count = 1;
   */ _define_property(this, "indexedCount", 0), /**
   * @generated from field: int32 skipped_count = 2;
   */ _define_property(this, "skippedCount", 0), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndexDocumentResponse, "runtime", proto3);
_define_property(IndexDocumentResponse, "typeName", "mono.rag.v1.IndexDocumentResponse");
_define_property(IndexDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "indexed_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "skipped_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.rag.v1.IndexBatchRequest
 */ export class IndexBatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new IndexBatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexBatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexBatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexBatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.rag.v1.IndexDocumentRequest documents = 3;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndexBatchRequest, "runtime", proto3);
_define_property(IndexBatchRequest, "typeName", "mono.rag.v1.IndexBatchRequest");
_define_property(IndexBatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "documents",
            kind: "message",
            T: IndexDocumentRequest,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.rag.v1.IndexBatchResponse
 */ export class IndexBatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new IndexBatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexBatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexBatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexBatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_indexed = 1;
   */ _define_property(this, "totalIndexed", 0), /**
   * @generated from field: int32 total_skipped = 2;
   */ _define_property(this, "totalSkipped", 0), /**
   * @generated from field: int32 documents_processed = 3;
   */ _define_property(this, "documentsProcessed", 0), /**
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IndexBatchResponse, "runtime", proto3);
_define_property(IndexBatchResponse, "typeName", "mono.rag.v1.IndexBatchResponse");
_define_property(IndexBatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_indexed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "documents_processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
